import {Table as AntTable} from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import {noop} from 'lodash';
import {IconUnfold} from '@baidu/ee-icon/svg';
import styles from './index.less';

const availableFaces = ['outline', 'border', 'header', 'more'];

const cx = classNames.bind(styles);

const More = ({hasMore, onLoadMore}) => (
    <div className={cx('more')}>
        {
            hasMore ? (
                <a onClick={onLoadMore}><IconUnfold />加载更多</a>
            ) : null // 可能会加“已是全部”之类的
        }
    </div>
);

More.propTypes = {
    hasMore: PropTypes.bool,
    onLoadMore: PropTypes.func
};

More.defaultProps = {
    hasMore: false,
    onLoadMore: noop
};

const ETUITable = ({size, className, face, hasMore, onLoadMore, ...restProps}) => {

    return (
        <div className={cx('root', `size-${size}`, face.map(option => (`face-${option}`)), className)}>
            <AntTable {...restProps} />
            {face.includes('more') && <More onLoadMore={onLoadMore} hasMore={hasMore} />}
        </div>
    );
};

Object.assign(ETUITable, AntTable);

ETUITable.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['s', 'm', 'l']),
    face: PropTypes.arrayOf((value, key, component) => {
        if (value.some(item => !availableFaces.includes(item))) {
            return new Error(`Invalid prop \`${value}\` supplied to \`${component}\`.`);
        }
        /* eslint consistent-return: 0 */
    }),
    hasMore: PropTypes.bool,
    onLoadMore: PropTypes.func
};

ETUITable.defaultProps = {
    className: '',
    size: 'm',
    face: [],
    hasMore: false,
    onLoadMore: noop
};

export default ETUITable;
